<template>
  <div class="container">
    <el-card class="card" shadow="never">
      <div slot="header" class="card-header">
        <h2>{{ $t("collectionList") }}</h2>
      </div>
      <el-container>
        <el-main>
          <!-- 筛选条件 -->
          <el-card class="filter-card">
            <el-form
              :inline="true"
              :model="filterForm"
              class="demo-form-inline"
            >
              <el-form-item :label="$t('routeName')">
                <el-input
                  v-model="filterForm.search"
                  :placeholder="$t('searchRoutePlaceholder')"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleFilter">
                  {{ $t("filter") }}
                </el-button>
                <el-button @click="resetFilter">
                  {{ $t("reset") }}
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>

          <!-- 订单列表 -->
          <el-table
            :data="collections"
            stripe
            border
            v-loading="loading"
            @row-click="handleRowClick"
          >
            <el-table-column prop="image" :label="$t('coverImage')" width="120">
              <template slot-scope="scope">
                <img
                  :src="scope.row.cover_image"
                  :alt="$t('routeCover')"
                  class="table-image"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="route_name"
              :label="$t('routeName')"
              width="220"
            ></el-table-column>
            <el-table-column
              prop="days"
              :label="$t('tripDays')"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="departure"
              :label="$t('departure')"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="destination"
              :label="$t('destination')"
              width="100"
            ></el-table-column>
            <el-table-column prop="price" :label="$t('price')" width="100">
              <template #default="scope">
                <span class="price">¥{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="collect_time"
              :label="$t('collectTime')"
              width="180"
            >
            </el-table-column>
            <el-table-column :label="$t('operation')" width="200">
              <template #default="scope">
                <el-button
                  size="small"
                  type="warning"
                  @click.stop="handleCancelCollection(scope.row.route_id)"
                >
                  {{ $t("cancelCollection") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页控件 -->
          <Pagination
            :total="total"
            :page-size="pageSize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-main>
      </el-container>
    </el-card>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";

export default {
  name: "OrderList",
  components: {
    Pagination,
  },
  data() {
    return {
      filterForm: {
        search: "",
        destination: "",
      },
      // 当前激活的 Tab
      total: 0,
      // 加载状态
      loading: false,
      // 订单数据
      collections: [],
      currentPage: 1,
      pageSize: 5,
    };
  },
  watch: {
    $route(to) {
      // 仅当路由参数包含 refresh=1 时刷新
      if (to.query.refresh === "1") {
        this.currentPage = 1;
        this.getFavoriteList();
        // 清除刷新标识，避免后续路由变化重复刷新
        this.$router.replace({ query: {} });
      }
    },
  },
  computed: {},
  created() {
    this.getFavoriteList();
  },
  methods: {
    // 调用后端接口
    async getFavoriteList() {
      this.loading = true;
      try {
        this.$get("/collection/list", {
          search: this.filterForm.search,
          page: this.currentPage,
          pageSize: this.pageSize,
        }).then((res) => {
          if (res.data.code === 1) {
            this.collections = res.data.data.list; // 更新订单数据
            this.total = res.data.data.total; // 更新总条数
          }
        });
      } catch (err) {
        this.$message.error(this.$t("loadListFailed"));
      } finally {
        this.loading = false;
      }
    },
    // 处理筛选
    handleFilter() {
      this.currentPage = 1; // 重置页码
      this.getFavoriteList();
    },
    // 重置筛选
    resetFilter() {
      this.filterForm = {
        search: "",
        destination: "",
      };
      this.currentPage = 1; // 重置页码
      this.getFavoriteList();
    },

    // 表格行点击跳转
    handleRowClick(row) {
      console.log(row, "pppp");
      // 跳转至路线详情页，携带路线ID（根据你的实际路由调整）
      this.$router.push({
        path: "/travel/route-detail",
        query: { id: row.route_id },
      });
    },

    handleCancelCollection(associated_id) {
      // 收藏/取消收藏方法
      this.$post("/collection/toggle", {
        associated_id, // 传递当前路线ID
      }).then((res) => {
        console.log(res.data, "ppp");
        if (res.data.code === 1) {
          this.isCollected = res.data.data.is_collected; // 更新前端收藏状态
          this.$message.success(res.data.msg);
          this.getFavoriteList(); // 重新获取订单列表
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 处理页码变化
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getFavoriteList();
    },
    // 处理每页数量变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置页码
      this.getFavoriteList();
    },
  },
};
</script>

<style scoped>
@import "@/assets/css/person-common.css";

::v-deep.el-table tr {
  cursor: pointer !important;
}
.table-image {
  width: 100px;
  height: 60px;
  object-fit: cover;
}

/* 价格样式 */
.price {
  color: #ff5500;
  font-weight: bold;
}

@media (max-width: 768px) {
  ::v-deep .card > .el-card__body {
    padding: 0px !important;
  }
}
</style>
